import Swiper from 'swiper'
import { Navigation, Pagination, EffectCreative } from 'swiper/modules'
import 'swiper/css/effect-creative'

const defaults = {
  spaceBetween: 24,
  overflowRight: false,
  navTarget: null,
}

const EFFECT_BREAKPOINT = 100

let anbaugebiete = []
let swiperInstance = null
let mountTarget = null
let options = {}
let panelObserver = null
let onWindowResize = null
let swipeCleanup = null

function extractFromDOM() {
  anbaugebiete = Array.from(document.querySelectorAll(`${mountTarget} .swiper-slide`)).map(slide => ({
    name: slide.dataset.name,
    headline: slide.dataset.headline,
    beschreibung: slide.dataset.beschreibung,
    bild: slide.querySelector('.anbaugebiet-card__image')?.getAttribute('src'),
  }))
}

function renderTextPanel(a) {
  return `
    <div class="anbaugebiet-slider__text-inner">
      <div class="anbaugebiet-card__name">${a.name}</div>
      <h4 class="anbaugebiet-card__headline">${a.headline}</h4>
      <p class="anbaugebiet-card__beschreibung">${a.beschreibung}</p>
    </div>
  `
}

function updateText(index) {
  const panel = document.querySelector(`${mountTarget} .anbaugebiet-slider__text`)
  if (!panel || !anbaugebiete[index]) return

  if (!isDesktop()) {
    panel.innerHTML = renderTextPanel(anbaugebiete[index])
    panel.classList.add('anbaugebiet-slider__text--visible')
    return
  }

  panel.style.setProperty('--after-height', panel.offsetHeight + 'px')
  panel.classList.remove('anbaugebiet-slider__text--visible')

  setTimeout(() => {
    panel.innerHTML = renderTextPanel(anbaugebiete[index])
    requestAnimationFrame(() => {
      panel.style.setProperty('--after-height', panel.offsetHeight + 'px')
      panel.classList.add('anbaugebiet-slider__text--visible')
    })
  }, 200)
}

function renderNav() {
  const nav = document.createElement('div')
  nav.className = 'swiper-nav'
  nav.classList.add( 'swiper-nav--region')
  nav.innerHTML = `
    <div class="swiper-button-prev"></div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-next"></div>
  `
  // const panel = document.querySelector(`${mountTarget} .anbaugebiet-slider__text`)
  // const wrapper = document.createElement('div')
  // wrapper.className = 'anbaugebiet-slider__text-wrapper'
  // panel.parentNode.insertBefore(wrapper, panel)
  // wrapper.appendChild(panel)
  // wrapper.appendChild(nav)
  document.querySelector(options.navTarget || mountTarget).appendChild(nav)  
}

function navSelector(btn) {
  const scope = options.navTarget || mountTarget
  return `${scope} .${btn}`
}

function isDesktop() {
  return window.innerWidth >= EFFECT_BREAKPOINT
}

function bindSwipeGesture(el) {
  if (swipeCleanup) swipeCleanup()

  let startX = 0
  let startY = 0
  let active = false
  const THRESHOLD = 50

  const onPointerDown = (e) => {
    if (e.button != null && e.button !== 0) return
    startX = e.clientX
    startY = e.clientY
    active = true
    el.setPointerCapture(e.pointerId)
    e.preventDefault()
    e.stopImmediatePropagation()
  }

  const onPointerMove = (e) => {
    if (!active) return
    e.preventDefault()
    e.stopImmediatePropagation()
  }

  const onPointerUp = (e) => {
    if (!active) return
    active = false
    e.stopImmediatePropagation()
    const dx = e.clientX - startX
    const dy = e.clientY - startY
    if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy)) return
    const btn = dx < 0
      ? document.querySelector(navSelector('swiper-button-next'))
      : document.querySelector(navSelector('swiper-button-prev'))
    btn?.click()
  }

  const onPointerCancel = () => { active = false }

  el.addEventListener('pointerdown', onPointerDown, { capture: true })
  el.addEventListener('pointermove', onPointerMove, { capture: true })
  el.addEventListener('pointerup', onPointerUp, { capture: true })
  el.addEventListener('pointercancel', onPointerCancel, { capture: true })

  swipeCleanup = () => {
    el.removeEventListener('pointerdown', onPointerDown, { capture: true })
    el.removeEventListener('pointermove', onPointerMove, { capture: true })
    el.removeEventListener('pointerup', onPointerUp, { capture: true })
    el.removeEventListener('pointercancel', onPointerCancel, { capture: true })
    swipeCleanup = null
  }
}

function initSwiper() {
  if (swiperInstance) swiperInstance.destroy(true, true)

  const desktop = isDesktop()

  const gap = desktop ? options.spaceBetween : 15

  swiperInstance = new Swiper(`${mountTarget} .swiper`, {
    modules: desktop ? [Navigation, Pagination, EffectCreative] : [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: gap,
    allowTouchMove: !desktop,
    simulateTouch: !desktop,
    ...(!desktop && {
      longSwipesRatio: 0.2,
      shortSwipes: true,
      threshold: 5,
      observer: true,
      observeParents: true,
    }),
    ...(desktop && {
      effect: 'creative',
      creativeEffect: {
        prev: { translate: [0, 0, 0], opacity: 0 },
        next: { translate: [`calc(100% + ${gap}px)`, 0, 0], opacity: 1 },
      },
    }),
    navigation: {
      nextEl: navSelector('swiper-button-next'),
      prevEl: navSelector('swiper-button-prev'),
      addIcons: false,
    },
    pagination: {
      el: navSelector('swiper-pagination'),
      clickable: true,
    },
    on: {
      activeIndexChange: (swiper) => { if (isDesktop()) updateText(swiper.activeIndex) },
      slideChangeTransitionEnd: (swiper) => { if (!isDesktop()) updateText(swiper.activeIndex) },
    },
  })

  if (desktop) {
    bindSwipeGesture(document.querySelector(`${mountTarget} .swiper`))
  } else if (swipeCleanup) {
    swipeCleanup()
  }
}

export function init(target = '#anbaugebiete', userOptions = {}) {
  mountTarget = target
  options = { ...defaults, ...userOptions }

  if (options.overflowRight) {
    document.querySelector(`${mountTarget} .anbaugebiet-slider`)
      ?.classList.add('anbaugebiet-slider--overflow-right')
  }

  extractFromDOM()
  renderNav()
  initSwiper()

  const panel = document.querySelector(`${mountTarget} .anbaugebiet-slider__text`)

  function syncPanelVars() {
    panel.style.setProperty('--after-height', panel.offsetHeight + 'px')
    panel.style.setProperty('--text-left', panel.getBoundingClientRect().left + 'px')
  }

  let resizeTimer = null
  panelObserver = new ResizeObserver(() => {
    panel.classList.add('anbaugebiet-slider__text--resizing')
    syncPanelVars()
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => panel.classList.remove('anbaugebiet-slider__text--resizing'), 150)
  })
  panelObserver.observe(panel)

  let wasDesktop = isDesktop()
  onWindowResize = () => {
    panel.style.setProperty('--text-left', panel.getBoundingClientRect().left + 'px')
    const nowDesktop = isDesktop()
    if (nowDesktop !== wasDesktop) {
      wasDesktop = nowDesktop
      initSwiper()
    }
  }
  window.addEventListener('resize', onWindowResize)

  syncPanelVars()
}

export function destroy() {
  if (swipeCleanup) swipeCleanup()
  if (swiperInstance) {
    swiperInstance.destroy(true, true)
    swiperInstance = null
  }
  if (panelObserver) {
    panelObserver.disconnect()
    panelObserver = null
  }
  if (onWindowResize) {
    window.removeEventListener('resize', onWindowResize)
    onWindowResize = null
  }
  anbaugebiete = []
}
